import type { ReactNode } from "react";

import type { FilterItem } from "./filter";

import { isValidElement } from "react";

import { TranslateGuard } from "../translate-guard";

type PLaceholderProps = {
	dynPlaceholder?: ReactNode;
	items: FilterItem[];
	placeholder: string;
	selected: null | string;
};

export function Placeholder({ dynPlaceholder, items, placeholder, selected }: PLaceholderProps) {
	if (dynPlaceholder) {
		if (isValidElement(dynPlaceholder)) {
			return dynPlaceholder;
		}
		return <TranslateGuard>{dynPlaceholder}</TranslateGuard>;
	}

	if (selected) {
		const selectedOption = items.find((option) => {
			return option.value === selected;
		});
		if (selectedOption) {
			if (isValidElement(selectedOption.label)) {
				return selectedOption.label;
			}
			return <span>{selectedOption.label}</span>;
		}
	}

	const resolvedLabel =
		items.find(({ value }) => {
			return value === selected;
		})?.label || placeholder;

	if (isValidElement(resolvedLabel)) {
		return resolvedLabel;
	}
	return <span>{resolvedLabel}</span>;
}
